<script>
import ButtonText from "@/components/Global/ButtonText.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";

export default {
  name: "DeleteOrderModal",
  emits: ["closeModal", "deleteOrder"],
  components: {ButtonPrimary, ButtonText},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<template>
  <div
      class="p-5 md:p-0 fixed w-full h-full flex justify-center items-center bg-overlay z-[55] top-0 left-0 bg-grays-900 bg-opacity-40"
  >
    <div
        class="bg-white w-full md:w-[660px] h-[360px] rounded overflow-hidden relative"
    >
      <div class="flex flex-col absolute left-0">
        <button
            class="mt-8 ml-8 w-9 h-9 rounded flex justify-center items-center"
            @click="closeModal"
        >
          <span class="material-symbols-rounded text-gray-700">close</span>
        </button>
      </div>
      <div class="w-full flex flex-col items-center justify-center h-full">
        <div class="text-error font-bold text-2xl items-center flex gap-2">
          <span class="text-error material-symbols-rounded text-xl">error</span>
          שימו לב!
        </div>
        <div
            class="text-grays-800 text-base mt-[35px] max-w-[500px] text-center p-5"
        >
          אתם מוחקים עכשיו את כל ההזמנה שלכם. תוכלו לפתוח את ההזמנה מחדש דרך לוח המכירות ולקנות מה שתרצו עד לסגירת
          המערכת.
        </div>
        <div
            class="absolute bottom-0 w-full border-t border-grays-300 flex flex-row-reverse px-8 mb-4 gap-2 items-end"
        >
          <button-primary
              class="mt-6 self-end"
              @click="$emit('deleteOrder')"
          >
            מאשרים
          </button-primary>
          <button-text @click="$emit('closeModal')"> להמשיך לקנות</button-text>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>